{
  "PAGINATION_FOOTER": {
    "SHOWING": "{startItem} - {endItem} / {totalItems} elem",
    "CURRENT_PAGE_INFO": "{currentPage} / {totalPages} oldal"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Válasszon egy lehetőséget...",
    "EMPTY_SEARCH_RESULTS": "Nincs találat erre a keresésre: `{searchTerm}`",
    "EMPTY_STATE": "Nincs találat.",
    "SEARCH_PLACEHOLDER": "Keresés...",
    "MORE": "+{count} további"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Keresés...",
    "EMPTY_STATE": "Nincs találat.",
    "SEARCHING": "Keresés..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Mégse",
      "CONFIRM": "Megerősítés"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Ország keresése",
    "ERROR": "A telefonszám legyen üres vagy E.164 formátumú",
    "DIAL_CODE_ERROR": "Kérlek, válassz egy hívószámot a listából"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "A szerző nem érhető el"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Navigációs útvonal"
  },
  "SWITCH": {
    "TOGGLE": "Kapcsoló átváltása"
  },
  "LABEL": {
    "TAG_BUTTON": "címke"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Tudj meg többet",
    "WATCH_VIDEO": "Videó megtekintése"
  },
  "COLOR_GRID": {
    "SHOW_COLORS": "Színek megjelenítése",
    "HIDE_COLORS": "Színek elrejtése"
  },
  "DURATION_INPUT": {
    "MINUTES": "Perc",
    "HOURS": "Óra",
    "DAYS": "Nap",
    "PLACEHOLDER": "Adja meg az időtartamot"
  }
}
